import { routes } from 'utils/routeHelper';

const routeByScope = [
  ['papi-location-patient-list', routes.MANAGE_PATIENTS],
  ['papi-patient-adherence-list', routes.MANAGE_PATIENT_ADHERENCE],
  ['papi-patient-list', routes.PATIENT_SUMMARY],
  ['papi-location-list-2', routes.MANAGE_LOCATIONS],
  ['papi-location-create', routes.MANAGE_LOCATIONS],
];

export const getRedirectUrl = (scopes: string[]): string => {
  const result = routeByScope.find((r) => scopes.includes(r[0]));
  if (result) return result[1];
  throw new Error(
    `from 'getRedirectUrl': no recognized scopes found in [${[...scopes]}]`,
  );
};
